import { useQuery } from "react-query";
import { fetchDpcData } from "../services/dpc/dpc.api";

export function useDpc(dpcId?: string) {
    const { data: dpc, ...rest } = useQuery(
        ["dpc", dpcId],
        () => fetchDpcData(dpcId!),
        {
            enabled: !!dpcId,
        }
    );

    return {
        dpc,
        ...rest,
    };
}
